import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const maxTopMargin = 2;
export const maxLineHeight = 1.5;

export const Container = styled.div<{
  $color?: string | null;
  $completed: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;

  border-radius: ${({ theme }) => theme.spacing(1.5)};
  background: ${({ theme }) => theme.palette.background.default};
  box-shadow: 0 0 1px 1px ${({ theme }) => theme.palette.background.default};
  overflow: hidden;

  color: ${({ theme }) => theme.palette.grey[600]};

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${({ theme }) => theme.palette.grey[50]};
    border: 1px solid ${({ theme }) => theme.palette.grey[300]};
    border-radius: ${({ theme }) => theme.spacing(1.5)};
  }

  ${({ $color }) =>
    $color &&
    css`
      &:before {
        background: ${rgba($color, 0.15)};
        border: 1px solid ${rgba($color, 0.3)};
      }
    `};

  ${({ $completed }) =>
    $completed &&
    css`
      opacity: 0.5;
    `};
`;

export const ExternalContainer = styled.div<{
  $color?: string | null;
  $bigGap?: boolean;
}>`
  position: relative;
  display: flex;
  gap: ${({ theme, $bigGap }) => theme.spacing($bigGap ? 1.5 : 0.5)};
  padding: ${({ theme }) => `0 ${theme.spacing(1)} 0 ${theme.spacing(2.5)}`};
  height: 100%;
  width: 100%;

  border-radius: ${({ theme }) => theme.spacing(1)};
  background: ${({ theme }) => theme.palette.grey[50]};
  box-shadow: 0 0 1px 1px ${({ theme }) => theme.palette.background.default};
  overflow: hidden;

  color: ${({ theme }) => theme.palette.text.primary};
  text-decoration: none;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${({ theme }) => theme.palette.background.default};
    border: 1px solid ${({ theme }) => theme.palette.grey[300]};
    border-radius: ${({ theme }) => theme.spacing(1)};
  }

  ${({ $color }) =>
    $color &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: 0.3rem;
        bottom: 0.3rem;
        left: 0.3rem;

        width: 0.3rem;
        background: ${$color};
        border-radius: ${({ theme }) => theme.spacing(2)};
      }
    `};
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  gap: ${({ theme }) => theme.spacing(0.25)};

  width: 100%;
  height: 100%;
`;

export const MetaContainer = styled.div`
  font-size: 1.6rem;
`;

export const RepeatIconContainer = styled.span<{ $color: string | undefined }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;

  font-size: 1.2rem;
  line-height: 62.5%;
  color: ${({ $color }) => ($color ? $color : 'inherit')};
`;

export const IconContainer = styled.div<{ $color?: string }>`
  font-size: 1.2rem;
  line-height: 62.5%;
  margin: ${({ theme }) => theme.spacing(1)};

  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `};
`;

export const Title = styled.span<{
  $marginTop: number;
  $lineHeight: number;
  $completed: boolean;
}>`
  position: relative;
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  flex: 1;

  overflow: hidden;

  color: ${({ theme }) => theme.palette.text.primary};
  margin-top: ${({ $marginTop }) => `${$marginTop}px`};
  line-height: ${({ $lineHeight }) => $lineHeight};
  word-wrap: break-word;

  ${({ $completed }) =>
    $completed &&
    css`
      text-decoration: line-through;
    `};
`;

export const DeadlineIconContainer = styled.span<{ $color?: string }>`
  display: block;

  margin: ${({ theme }) => theme.spacing(1)};

  font-size: 1.2rem;
  line-height: 1.2rem;

  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `};
`;
